/**
 * Shared page chrome for Phase 2 initiation screens (IN-00–IN-05).
 */
export default function InitiationLayout({ title, subtitle, badge, actions, children }) {
  return (
    <div className="content">
      <div className="hero" style={{ alignItems: 'center' }}>
        <div>
          <div className="tbtitle" style={{ marginBottom: 4 }}>{title}</div>
          {subtitle && <div className="tbcrumb">{subtitle}</div>}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
          {badge}
          {actions}
        </div>
      </div>
      {children}
    </div>
  );
}
